import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signalRService } from '../services/signalRService';
import { fetchReservations } from '../features/reservations/reservationsSlice';
import { fetchVehicles } from '../features/vehicles/vehiclesSlice';
import { fetchClients } from '../features/clients/clientsSlice';
import { fetchContrats } from '../features/contrats/contratsSlice';
import { fetchFactures } from '../features/factures/facturesSlice';
import { fetchCautions } from '../features/cautions/cautionsSlice';
import { fetchAssurances } from '../features/assurances/assurancesSlice';
import { fetchVidanges } from '../features/vidanges/vidangesSlice';
import { fetchVisites } from '../features/visitesTechniques/visitesTechniquesSlice';
import { fetchDashboard } from '../features/dashboard/dashboardSlice';

// Entité backend → slices Redux à rafraîchir
const ENTITY_MAP = {
  Reservation:     ['reservations', 'vehicles', 'dashboard'],
  Vehicule:        ['vehicles', 'dashboard'],
  Client:          ['clients'],
  Contrat:         ['contrats'],
  Facture:         ['factures', 'dashboard'],
  Caution:         ['cautions', 'dashboard'],
  Assurance:       ['assurances'],
  Vidange:         ['vidanges'],
  VisiteTechnique: ['visites'],
};

const FETCH_THUNK = {
  reservations: fetchReservations,
  vehicles:     fetchVehicles,
  clients:      fetchClients,
  contrats:     fetchContrats,
  factures:     fetchFactures,
  cautions:     fetchCautions,
  assurances:   fetchAssurances,
  vidanges:     fetchVidanges,
  visites:      fetchVisites,
  dashboard:    fetchDashboard,
};

/**
 * Hook global monté dans AppShell.
 * Gère le cycle de vie de la connexion SignalR et dispatch les thunks Redux
 * appropriés quand le backend pousse un événement EntityUpdated.
 */
export const useSignalR = () => {
  const user = useSelector(s => s.auth.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) {
      signalRService.stop();
      return;
    }

    signalRService.start();

    const unsub = signalRService.on('EntityUpdated', (entities) => {
      const toRefresh = new Set();
      [].concat(entities).forEach(entity => {
        (ENTITY_MAP[entity] ?? []).forEach(slice => toRefresh.add(slice));
      });
      toRefresh.forEach(slice => {
        if (FETCH_THUNK[slice]) dispatch(FETCH_THUNK[slice]());
      });
    });

    return unsub;
  }, [user, dispatch]);
};
